import { useEffect } from "react";
import { MainTable } from "../../../Components/Macro/MainTable/MainTable";
import { useAuthors } from "./AuthorsState";
import Add from "./Add";
import Edit from "./Edit";

export const Authors = () => {
    let { columns, cats, setCat, removeCat, setEd } = useAuthors();
    useEffect(() => {
        setCat()
    }, [])
    return (
        <>
            <MainTable
                pcolumns={columns}
                pdata={cats}
                pageTitle={"Kitob mualliflari"}
                add={<Add />}
                onDelete={removeCat}
                edit={<Edit />}
                onEdit={(item) => {
                    setEd(item)
                }}
                setEd={setEd}
                defkey={'id'}
            />
        </>
    )
}